import React from "react";
import { MakeLabelParams } from "../../types/MakeLabelParams";
import { LinkInternal } from "./LinkInternal/LinkInternal";

export const makeLinkInternalLabel = (data: MakeLabelParams) => (
  <LinkInternal params={data} />
);
